/* ===========================================================
   Plafonniers Design — accueil
   Deux comportements indépendants : le carrousel de sélection
   et la porte d'entrée en modale. Aucun des deux n'est
   nécessaire à la lecture de la page : sans JS le carrousel
   reste un rail qui défile au doigt, et la modale ne s'ouvre pas.
   =========================================================== */
(function () {
  'use strict';

  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- carrousel ---------------- */
  function carrousel(racine) {
    var rail = racine.querySelector('[data-pd-rail]');
    if (!rail) return;

    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) return;

    var prec = racine.querySelector('[data-pd-prec]');
    var suiv = racine.querySelector('[data-pd-suiv]');
    var puces = racine.querySelector('[data-pd-puces]');
    var delai = parseInt(racine.getAttribute('data-pd-delai'), 10) || 0;
    var minuteur = null;
    var index = 0;

    // Combien de vignettes tiennent côte à côte : sert à ne pas
    // faire défiler au-delà de la dernière.
    function parEcran() {
      var large = items[0].getBoundingClientRect().width;
      if (!large) return 1;
      var ecart = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return Math.max(1, Math.round((rail.clientWidth + ecart) / (large + ecart)));
    }

    // Dernière position atteignable. Au-delà, le rail est en butée :
    // il y a donc dernier() + 1 positions, et autant de puces — pas
    // une par vignette, sinon les dernières ne s'allument jamais.
    function dernier() {
      return Math.max(0, items.length - parEcran());
    }

    function aller(i, doux) {
      var max = dernier();
      if (i < 0) i = max;
      if (i > max) i = 0;
      index = i;
      rail.scrollTo({
        left: items[i].offsetLeft - items[0].offsetLeft,
        behavior: doux && !calme ? 'smooth' : 'auto'
      });
      marquer();
    }

    function marquer() {
      if (!puces) return;
      var boutons = puces.children;
      for (var i = 0; i < boutons.length; i++) {
        boutons[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    function construirePuces() {
      if (!puces) return;
      var n = dernier() + 1;
      if (n < 2) { puces.textContent = ''; return; }
      if (puces.childElementCount === n) { marquer(); return; }
      puces.textContent = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdCar__dot';
        b.setAttribute('aria-label', 'Aller à la proposition ' + (i + 1));
        b.addEventListener('click', (function (k) {
          return function () { arreter(); aller(k, true); };
        })(i));
        puces.appendChild(b);
      }
      marquer();
    }

    // L'index suit aussi un défilement fait à la main.
    var attente = null;
    rail.addEventListener('scroll', function () {
      if (attente) window.clearTimeout(attente);
      attente = window.setTimeout(function () {
        var origine = items[0].offsetLeft;
        var proche = 0;
        var mini = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - origine - rail.scrollLeft);
          if (d < mini) { mini = d; proche = i; }
        }
        index = Math.min(proche, dernier());
        marquer();
      }, 90);
    }, { passive: true });

    function arreter() {
      if (minuteur) { window.clearInterval(minuteur); minuteur = null; }
    }
    function lancer() {
      if (!delai || calme || minuteur) return;
      minuteur = window.setInterval(function () { aller(index + 1, true); }, delai);
    }

    if (prec) prec.addEventListener('click', function () { arreter(); aller(index - 1, true); });
    if (suiv) suiv.addEventListener('click', function () { arreter(); aller(index + 1, true); });

    // On ne fait pas tourner sous le nez de quelqu'un qui regarde,
    // ni quand l'onglet est en arrière-plan.
    racine.addEventListener('pointerenter', arreter);
    racine.addEventListener('focusin', arreter);
    racine.addEventListener('pointerleave', lancer);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) arreter(); else lancer();
    });

    // Le nombre de vignettes visibles change avec la largeur :
    // les puces se reconstruisent en conséquence.
    var redim = null;
    window.addEventListener('resize', function () {
      if (redim) window.clearTimeout(redim);
      redim = window.setTimeout(function () {
        construirePuces();
        aller(Math.min(index, dernier()), false);
      }, 160);
    }, { passive: true });

    construirePuces();
    lancer();
  }

  /* ---------------- porte d'entrée ---------------- */
  function porte(dialogue) {
    if (typeof dialogue.showModal !== 'function') return;

    var cle = 'pd-porte-vue';
    var attente = parseInt(dialogue.getAttribute('data-pd-attente'), 10);
    if (isNaN(attente)) attente = 700;

    // En mode édition du thème on montre toujours la modale pour
    // pouvoir la régler, mais on ne retient jamais le choix.
    var edition = document.documentElement.classList.contains('shopify-design-mode');

    function dejaVue() {
      if (edition) return false;
      try { return window.sessionStorage.getItem(cle) === '1'; } catch (e) { return false; }
    }
    function retenir() {
      if (edition) return;
      try { window.sessionStorage.setItem(cle, '1'); } catch (e) { /* navigation privée */ }
    }

    if (dejaVue()) return;

    window.setTimeout(function () {
      if (!dialogue.isConnected || dialogue.open) return;
      dialogue.showModal();
    }, attente);

    // Refuser : par le bouton, par Échap, ou en cliquant à côté.
    // Dans les trois cas on retient, pour ne pas reposer la question
    // à chaque page de la visite.
    dialogue.addEventListener('close', retenir);

    var refus = dialogue.querySelector('[data-pd-refus]');
    if (refus) refus.addEventListener('click', function () { dialogue.close(); });

    dialogue.addEventListener('click', function (e) {
      if (e.target === dialogue) dialogue.close();
    });

    // Choisir l'une des deux portes vaut réponse : la page change sans
    // que le dialogue se ferme, donc on retient ici, pour ne pas reposer
    // la question au retour sur l'accueil.
    var choix = dialogue.querySelectorAll('a[href]');
    for (var k = 0; k < choix.length; k++) choix[k].addEventListener('click', retenir);
  }

  function demarrer() {
    var cars = document.querySelectorAll('[data-pd-carrousel]');
    for (var i = 0; i < cars.length; i++) carrousel(cars[i]);

    var portes = document.querySelectorAll('[data-pd-porte]');
    for (var j = 0; j < portes.length; j++) porte(portes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();